$(document).ready(function(){
	const notificationEl = $('.notification');
	$('[data-encouragement-decline]').on('click', function() {
		const $declineButton = $(this);
		if ($declineButton.hasClass('is-selected') || $declineButton.prop('disabled')) {
			return;
		}
		const $formLink = $('[data-encouragement-form-link]');
		const $preferenceForm = $('[data-encouragement-preference-form]');
		const isSelected = true;

		if (!window.confirm('Êtes-vous sûr·e de ne pas vouloir faire de demande d’encouragement ? Une fois confirmé, le formulaire ne sera plus accessible. L’administration pourra toutefois réactiver votre accès.')) {
			return;
		}

		if (isSelected) {
			$formLink.data('encouragement-form-href', $formLink.attr('href') || '/organizers/encouragement')
				.addClass('organizersBilan__button--disabled')
				.attr('aria-disabled', 'true')
				.removeAttr('href');
		} else {
			$formLink
				.removeClass('organizersBilan__button--disabled')
				.attr('aria-disabled', 'false')
				.attr('href', $formLink.data('encouragement-form-href'));
		}

		$declineButton.toggleClass('is-selected', isSelected).attr('aria-pressed', String(isSelected));
		$declineButton.prop('disabled', true);
		$preferenceForm.find('[name="fields[encouragementDeclined]"]').val(isSelected ? '1' : '');
		$.post($preferenceForm.attr('action') || window.location.href, $preferenceForm.serialize());
	});

	// -- encouragement form steps --
	const $encouragementForm = $('.organizersEncouragementPage__form');
	const $convention = $('.organizersEncouragementStatus__convention');
	if ($convention.length) {
		const $signer = $convention.find('#organizersConventionSigner');
		const $confirmation = $convention.find('input[type="checkbox"]');
		const $signButton = $convention.find('button[type="button"]');
		const ribConfirmed = $convention.attr('data-convention-rib-confirmed') === '1';
		const signUrl = $convention.attr('data-convention-sign-url');
		const updateConventionButton = function() {
			const canSign = ribConfirmed && $.trim($signer.val()) !== '' && $confirmation.is(':checked');

			$signButton
				.prop('disabled', !canSign)
				.toggleClass('is-ready', canSign);
		};
		$signer.on('input', updateConventionButton);
		$confirmation.on('change', updateConventionButton);
		$signButton.on('click', function() {
			if ($signButton.prop('disabled') || !signUrl) {
				return;
			}

			const data = $convention.find('input[type="hidden"], #organizersConventionSigner, input[name="certification"]').serialize();
			$signButton.prop('disabled', true).text('Enregistrement...');

			$.post(signUrl, data)
				.done(function(response) {
					if (response.success) {
						$convention.find('.organizersEncouragementStatus__conventionBadge').text('Signée');
						$signButton.text('Convention signée');
						return;
					}
					$signButton.prop('disabled', false).text('Signer la convention');
				})
				.fail(function(xhr) {
					$signButton.prop('disabled', false).text('Signer la convention');
					window.alert(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : 'La signature n’a pas pu être enregistrée.');
				});
		});
		updateConventionButton();
	}
	const $formieEncouragementForm = $('.organizersEncouragementPage__formie .fui-form');
	const formatEncouragementDate = function(value) {
		const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
		return match ? match[3] + '/' + match[2] + '/' + match[1] : value;
	};
	const getEncouragementSignaturePage = function() {
		const form = $formieEncouragementForm[0];
		const theme = form && form.formTheme;
		const pages = theme && theme.settings && theme.settings.pages ? theme.settings.pages : [];
		let pageIndex = pages.findIndex(function(page) {
			return String(page.label || '').toLowerCase().includes('signature');
		});
		if (pageIndex < 0) {
			pageIndex = 6;
		}
		return $formieEncouragementForm.find('.fui-page').eq(pageIndex);
	};
	const ensureEncouragementSignatureSummary = function() {
		const $page = getEncouragementSignaturePage();
		if (!$page.length) {
			return $();
		}
		$page.find('[data-field-handle="signatureSummary"]').remove();
		let $summary = $page.find('.encouragement-signature-summary').first();
		if (!$summary.length) {
			$summary = $('<div class="encouragement-signature-summary" aria-live="polite">' +
				'<h3>Récapitulatif</h3>' +
				'<p>Événement : <span data-encouragement-summary="event">—</span></p>' +
				'<p>Dates : du <span data-encouragement-summary="startDate">—</span> au <span data-encouragement-summary="endDate">—</span> (<span data-encouragement-summary="days">0</span> <span data-encouragement-summary="dayLabel">jours</span>)</p>' +
				'<p>Budget total : <strong data-encouragement-summary="budget">0 €</strong></p>' +
			'</div>');
		}
		const $firstSignatureField = $page.find('.fui-field, .fui-row').first();
		if ($firstSignatureField.length && !$firstSignatureField.prev().is($summary)) {
			$firstSignatureField.before($summary);
		} else if (!$firstSignatureField.length) {
			const $buttonWrapper = $page.find('.fui-btn-wrapper').first();
			if ($buttonWrapper.length && !$buttonWrapper.prev().is($summary)) {
				$buttonWrapper.before($summary);
			} else if (!$buttonWrapper.length && !$page.children().first().is($summary)) {
				$page.prepend($summary);
			}
		}
		return $summary;
	};
	const updateSignatureSummaryFromSeed = function() {
		const $wrapper = $('.organizersEncouragementPage__formie').first();
		const $summary = ensureEncouragementSignatureSummary();
		const rawSeed = $wrapper.attr('data-signature-values');
		if (!$summary.length || !rawSeed || $summary.find('[data-encouragement-summary="event"]').text() !== '—') {
			return;
		}
		try {
			const seed = JSON.parse(rawSeed);
			const expenses = ['artistFees', 'sacemFees', 'artistTravel', 'venueEquipment', 'equipmentPurchase', 'technicianFees', 'insuranceFees', 'roadPerDiem', 'printingFees', 'photoVideoFees', 'marketingFees'].reduce(function(total, handle) {
				return total + (parseFloat(String(seed[handle] || '').replace(',', '.')) || 0);
			}, 0);
			const format = function(value) {
				return new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2}).format(value) + ' €';
			};
			const eventName = String(seed.eventName || '—');
			const eventLocation = String(seed.eventLocation || '');
			const startDate = String(seed.eventStartDate || '—');
			const endDate = String(seed.eventEndDate || '—');
			const start = new Date(startDate + 'T12:00:00');
			const end = new Date(endDate + 'T12:00:00');
			const days = startDate !== '—' && endDate !== '—' && !isNaN(start) && !isNaN(end) && end >= start
				? Math.floor((end - start) / 86400000) + 1
				: 0;
			$summary.find('[data-encouragement-summary="event"]').text(eventName + (eventLocation ? ' — ' + eventLocation : ''));
			$summary.find('[data-encouragement-summary="startDate"]').text(formatEncouragementDate(startDate));
			$summary.find('[data-encouragement-summary="endDate"]').text(formatEncouragementDate(endDate));
			$summary.find('[data-encouragement-summary="days"]').text(days);
			$summary.find('[data-encouragement-summary="dayLabel"]').text(days === 1 ? 'jour' : 'jours');
			$summary.find('[data-encouragement-summary="grant"]').text(format(parseFloat(String(seed.grantRequested || '').replace(',', '.')) || 0));
			$summary.find('[data-encouragement-summary="budget"]').text(format(expenses));
		} catch (error) {
			// Ignore optional seed data and let the live Formie updater handle it.
		}
	};
	updateSignatureSummaryFromSeed();
	$(document).on('onFormieThemeReady', updateSignatureSummaryFromSeed);
	window.setTimeout(updateSignatureSummaryFromSeed, 500);
	if ($formieEncouragementForm.length) {
		const formieEncouragementForm = $formieEncouragementForm[0];
		const organizerSignatureLocation = String($formieEncouragementForm.closest('.organizersEncouragementPage__formie').attr('data-signature-location') || '').trim();
		const syncOrganizerSignatureLocation = function() {
			if (!organizerSignatureLocation) {
				return;
			}
			let $input = $formieEncouragementForm.find('[name="fields[signatureLocation]"], [name*="[signatureLocation]"]').first();
			if (!$input.length) {
				$input = $formieEncouragementForm.find('[data-field-handle="signatureLocation"] input').first();
			}
			if ($input.length && String($input.val() || '').trim() !== organizerSignatureLocation) {
				$input.val(organizerSignatureLocation).trigger('input');
			}
		};
		syncOrganizerSignatureLocation();
		$formieEncouragementForm.on('onFormieThemeReady onFormiePageToggle', function() {
			window.setTimeout(syncOrganizerSignatureLocation, 0);
		});
		const signatureCacheHandles = [
			'eventName',
			'eventLocation',
			'eventStartDate',
			'eventEndDate',
			'grantRequested',
			'artistFees',
			'sacemFees',
			'artistTravel',
			'venueEquipment',
			'equipmentPurchase',
			'technicianFees',
			'insuranceFees',
			'roadPerDiem',
			'printingFees',
			'photoVideoFees',
			'marketingFees'
		];
		const signatureValueCache = {};
		const signatureSeed = $formieEncouragementForm.closest('.organizersEncouragementPage__formie').attr('data-signature-values');
		if (signatureSeed) {
			try {
				Object.assign(signatureValueCache, JSON.parse(signatureSeed));
			} catch (error) {
				// Ignore malformed optional seed data and continue with live field values.
			}
		}
		const cacheSignatureControl = function(control) {
			const $control = $(control);
			const fieldHandle = String($control.closest('[data-field-handle]').attr('data-field-handle') || '').split('.').pop();
			const name = String($control.attr('name') || '');
			const nameHandle = (name.match(/\[([^\]]+)\]/g) || []).map(function(value) {
				return value.slice(1, -1);
			}).find(function(value) {
				return signatureCacheHandles.indexOf(value) !== -1;
			});
			const handle = signatureCacheHandles.indexOf(fieldHandle) !== -1 ? fieldHandle : nameHandle;
			if (handle) {
				signatureValueCache[handle] = String($control.val() || '').trim();
			}
		};
		$(document).on('input change', '.organizersEncouragementPage__formie .fui-form input, .organizersEncouragementPage__formie .fui-form textarea, .organizersEncouragementPage__formie .fui-form select', function() {
			cacheSignatureControl(this);
		});
		const saveProgressUrl = $formieEncouragementForm.closest('.organizersEncouragementPage__formie').attr('data-save-progress-url');
		const arrangeFormieButtons = function() {
			$formieEncouragementForm.find('.fui-btn-wrapper').each(function() {
				const $wrapper = $(this);
				const $page = $wrapper.closest('.fui-page');
				let $previous = $wrapper.find('.fui-prev').first();
				const $save = $wrapper.find('.fui-save').first();
				const $submit = $wrapper.find('.fui-submit').first();

				if (!$previous.length) {
					$previous = $page.children('.fui-prev').first();
				}

				if ($page.is(':first-child')) {
					$previous.remove();
					$previous = $();
				}

				$wrapper.append($previous, $save, $submit);
				$wrapper.toggleClass('has-previous', $previous.length > 0);
			});
		};

		// Formie has persisted the incomplete submission before this event fires.
		// Redirect only for the Save action; normal page navigation is untouched.
		formieEncouragementForm.addEventListener('onAfterFormieSubmit', function(event) {
			const theme = formieEncouragementForm.formTheme;
			const submitAction = theme && theme.form ? theme.form.submitAction : null;

			if (event.detail && event.detail.success && submitAction === 'save' && saveProgressUrl) {
				// Formie adds the saved submission ID immediately after this event.
				// Wait for that update, then sync the unload guard before redirecting.
				window.setTimeout(function() {
					if (theme) {
						theme.updateFormHash();
					}
					window.location.assign(saveProgressUrl);
				}, 0);
			}
		});

		const returnFromAdminPage = function() {
			const form = $formieEncouragementForm[0];
			const theme = form && form.formTheme;
			if (!theme) {
				return;
			}

			const currentPage = theme.getCurrentPage();
			if (!currentPage || currentPage.label !== 'Administration') {
				return;
			}

			const currentIndex = theme.getCurrentPageIndex();
			const previousPage = theme.settings.pages[currentIndex - 1];
			const $previousTab = $formieEncouragementForm.find('[data-fui-page-tab]').eq(currentIndex - 1);
			const $previousLink = $previousTab.find('[data-fui-page-tab-anchor]').first();
			if (previousPage && $previousLink.length) {
				theme.setPage({
					pageIndex: currentIndex - 1,
					pageId: previousPage.id,
					action: $previousLink.attr('href'),
				});
			}
		};

		$formieEncouragementForm.on('onFormieThemeReady', function() {
			arrangeFormieButtons();
			returnFromAdminPage();
		});
		arrangeFormieButtons();
		returnFromAdminPage();

		const $formieStepTabs = $formieEncouragementForm.find('.fui-tab a');
		$formieStepTabs
			.removeAttr('href')
			.attr({
				'tabindex': '-1',
				'aria-disabled': 'true'
			})
			.css({
				'cursor': 'default',
				'pointer-events': 'none'
			});
		$formieEncouragementForm.on('click', '.fui-tab a', function(event) {
			event.preventDefault();
		});

		const agreementLabels = [
			"J’adhère aux principes de la Fête de la Musique (<a href=\"/organizers/charte\" target=\"_blank\" rel=\"noopener\">charte de partenariat</a>).",
			"J’ai pris connaissance du <a href=\"/resources/documents/reglement-encouragement-2026-10-12.pdf\" target=\"_blank\" rel=\"noopener\">règlement (PDF)</a> et des critères d’éligibilité.",
			"J'ai pris connaissance des consignes de budget (frais de personnel salarié d'une autre entité et frais de gastronomie non éligibles).",
			"Je certifie sur l'honneur l'exactitude des informations transmises."
		];
		let $agreementFields = $formieEncouragementForm.find('[data-field-handle="principles"], [data-field-handle="eligibility"], [data-field-handle="budgetAttestation"], [data-field-handle="signatureCertification"]');
		if (!$agreementFields.length) {
			$agreementFields = $formieEncouragementForm.find('.fui-page').first().find('.fui-type-agree, [data-field-type="agree"]');
		}
		if (!$agreementFields.length) {
			$agreementFields = $formieEncouragementForm.find('.fui-page').first().find('input[type="checkbox"]').closest('.fui-field, fieldset');
		}
		$agreementFields.each(function(index) {
			const $field = $(this);
			let $label = $field.find('.fui-checkbox-label').first();
			const $input = $field.find('input[type="checkbox"]').first();
			$field.addClass('encouragement-agreement');
			const $container = $field.find('.fui-field-container').first().length
				? $field.find('.fui-field-container').first()
				: $field;
			$field.css({
				'grid-column': '1 / -1',
				'width': '100%',
				'max-width': '100%',
				'flex': '0 0 100%'
			});
			$field.closest('.fui-row').css({
				'grid-template-columns': 'minmax(0, 1fr)'
			});
			$container.css({
				'box-sizing': 'border-box',
				'display': 'flex',
				'align-items': 'center',
				'width': '100%',
				'padding': '14px 16px',
				'border-radius': '12px',
				'background-color': '#FAF6EC'
			});
			$container[0].style.setProperty('display', 'flex', 'important');
			$container[0].style.setProperty('align-items', 'center', 'important');
			$field.find('.fui-checkbox').css({
				'display': 'flex',
				'align-items': 'center',
				'margin': '0',
				'padding': '0'
			});
			$field.find('.fui-checkbox').each(function() {
				this.style.setProperty('display', 'flex', 'important');
				this.style.setProperty('align-items', 'center', 'important');
				this.style.setProperty('margin', '0', 'important');
				this.style.setProperty('padding', '0', 'important');
				this.style.setProperty('transform', 'translateY(-7px)', 'important');
			});
			$field.css({
				'margin': '0',
				'padding-bottom': '0'
			});
			if (!$label.length) {
				const inputId = $input.attr('id');
				if (inputId) {
					$input.after($('<label>', {
						class: 'fui-checkbox-label',
						for: inputId
					}));
					$label = $field.find('.fui-checkbox-label').first();
				}
			}
			if ($label.length && agreementLabels[index]) {
				$label.html(agreementLabels[index]);
				$label.css({
					'display': 'block',
					'position': 'relative',
					'min-height': '17px',
					'margin': '0',
					'padding': '0 0 0 29px',
					'color': '#132239',
					'font-size': '14px',
					'font-weight': '400',
					'line-height': '1.5',
					'letter-spacing': '0',
					'text-transform': 'none'
				});
				$label[0].style.setProperty('display', 'block', 'important');
			}
			$field.find('.fui-errors, .fui-error-message, [data-field-error-messages]').css({
				'margin': '8px 0 0',
				'padding': '0',
				'line-height': '1.35'
			});
		});

		const $firstPage = $formieEncouragementForm.find('.fui-page').first();
		const $firstPageAgreements = $firstPage.find('.encouragement-agreement input[type="checkbox"]');
		const $firstPageContinue = $firstPage.find('.fui-btn-wrapper .fui-btn').not('[data-encouragement-previous]').last();
		const updateAgreementButton = function() {
			const allAccepted = $firstPageAgreements.length >= 2 && $firstPageAgreements.toArray().every(function(input) {
				return input.checked;
			});
			$firstPageContinue
				.prop('disabled', !allAccepted)
				.toggleClass('is-disabled', !allAccepted)
				.attr('aria-disabled', String(!allAccepted));
		};
		$firstPageAgreements.on('change', updateAgreementButton);
		updateAgreementButton();

		const $budgetAttestation = $formieEncouragementForm
			.find('[data-field-handle="budgetAttestation"] input[type="checkbox"], [data-field-handle$=".budgetAttestation"] input[type="checkbox"]')
			.first();
		const $budgetPage = $budgetAttestation.closest('.fui-page');
		const $budgetContinue = $budgetPage.find('.fui-next').first();
		let budgetIsBalanced = false;
		const updateBudgetContinueState = function() {
			const isAccepted = $budgetAttestation.is(':checked') && budgetIsBalanced;
			$budgetContinue
				.prop('disabled', !isAccepted)
				.toggleClass('is-disabled', !isAccepted)
				.attr('aria-disabled', String(!isAccepted));
		};
		$budgetAttestation.on('change', updateBudgetContinueState);
		$formieEncouragementForm.on('onFormiePageToggle', function() {
			window.setTimeout(updateBudgetContinueState, 0);
		});
		updateBudgetContinueState();

		const $informationPage = $formieEncouragementForm.find('.fui-page').eq(1);
		const findDateInput = function(handle) {
			let $field = $informationPage.find('[data-field-handle="' + handle + '"], [data-field-handle*="' + handle + '"]').first();
			let $input = $field.find('input').first();
			if (!$input.length) {
				$input = $informationPage.find('input[name*="[' + handle + ']"]').first();
			}
			return $input;
		};
		const $startDate = findDateInput('eventStartDate');
		const $endDate = findDateInput('eventEndDate');
		if ($startDate.length && $endDate.length) {
			let $dateFieldsRow = $informationPage.find('.fui-row').filter(function() {
				const $row = $(this);
				return $row.find('[data-field-handle="eventStartDate"]').length && $row.find('[data-field-handle="eventEndDate"]').length;
			}).first();
			if (!$dateFieldsRow.length) {
				$dateFieldsRow = $startDate.parents('.fui-row').filter(function() {
					return $.contains(this, $endDate[0]);
				}).first();
			}
			const $dateRow = $dateFieldsRow.length ? $dateFieldsRow : $startDate.closest('.fui-row');
			const $daysNotice = $('<div class="fui-event-days">Nombre total de jours : 0</div>');
			if (!$informationPage.find('.fui-event-days').length && $dateRow.length) {
				$dateRow.after($daysNotice);
			} else {
				$informationPage.find('.fui-event-days').first().replaceWith($daysNotice);
			}
			const updateDaysNotice = function() {
				const startValue = $startDate.val();
				const endValue = $endDate.val();
				const start = new Date(startValue + 'T12:00:00');
				const end = new Date(endValue + 'T12:00:00');
				let days = 0;
				if (startValue && endValue && !isNaN(start) && !isNaN(end) && end >= start) {
					days = Math.floor((end - start) / 86400000) + 1;
				}
				$daysNotice.text('Nombre total de jours : ' + days);
			};
			$startDate.add($endDate).on('change input', updateDaysNotice);
			updateDaysNotice();
		}

		const $buttonWrapper = $formieEncouragementForm.find('.fui-page:not([data-fui-page-hidden="true"]) .fui-btn-wrapper').first();
		if ($buttonWrapper.length && !$buttonWrapper.find('[data-encouragement-previous]').length) {
			$buttonWrapper.prepend('<button type="button" class="fui-btn fui-previous is-disabled" data-encouragement-previous disabled>&larr; PRÉCÉDENT</button>');
		}
		const findFormieField = function(handle, label) {
			let $field = $formieEncouragementForm.find('[data-field-handle="' + handle + '"], [data-field-handle*="' + handle + '"]').first();
			if (!$field.length) {
				$field = $formieEncouragementForm.find('[name*="' + handle + '"]').first().closest('.fui-field');
			}
			if (!$field.length) {
				$field = $formieEncouragementForm.find('.fui-label, .fui-legend').filter(function() {
					return $.trim($(this).text()).toLowerCase().indexOf(label.toLowerCase()) === 0;
				}).first().closest('.fui-field');
			}
			return $field;
		};

		const $targetAudienceField = findFormieField('targetAudience', 'Public cible');
		$targetAudienceField.addClass('encouragement-target-audience');

		const $stageCountLabel = $formieEncouragementForm.find('.fui-label, .fui-legend').filter(function() {
			return $.trim($(this).text()).toLowerCase().indexOf('nombre de scènes') === 0;
		}).first();
		const $stageCountField = $stageCountLabel.length
			? $stageCountLabel.closest('.fui-field')
			: findFormieField('stageCount', 'Nombre de scènes');
		$stageCountField.addClass('encouragement-stage-count');
		const cleanStageCountControls = function($select) {
			const $selectWrapper = $select.closest('.fui-input-wrapper');
			$stageCountField.find('.nice-select').remove();
			$stageCountField.find('select, input').not('[type="hidden"]').not($select).remove();
			$stageCountField.find('.fui-input-wrapper').not($selectWrapper).remove();
		};
		const replaceStageCountControl = function() {
			const $currentControl = $stageCountField.find('select, input').not('[type="hidden"]').first();
			if (!$currentControl.length) {
				return;
			}
			if ($currentControl.hasClass('encouragement-stage-count__select')) {
				cleanStageCountControls($currentControl);
				return;
			}
			if ($currentControl.is('select') && $currentControl.next('.nice-select').length && $.fn.niceSelect) {
				$currentControl.niceSelect('destroy');
			}

			const currentValue = String($currentControl.val() || '1');
			const $select = $('<select>', {
				class: ($currentControl.attr('class') || 'fui-input') + ' encouragement-stage-count__select',
				id: $currentControl.attr('id'),
				name: $currentControl.attr('name'),
				'data-native-select': '',
				'aria-label': 'Nombre de scènes'
			});
			const existingOptions = $currentControl.is('select') ? $currentControl.find('option') : $();
			if (existingOptions.length > 1) {
				existingOptions.each(function() {
					$select.append($(this).clone());
				});
			} else {
				for (let count = 1; count <= 6; count++) {
					$select.append($('<option>', {value: String(count), text: count === 6 ? '6+' : String(count)}));
				}
			}
			$.each($currentControl.data(), function(key, value) {
				$select.attr('data-' + key.replace(/[A-Z]/g, function(letter) {
					return '-' + letter.toLowerCase();
				}), value);
			});
			$currentControl.replaceWith($select);
			$select.val(currentValue);
			cleanStageCountControls($select);
		};
		replaceStageCountControl();
		const enableStageCount = function() {
			const $stageControl = $stageCountField.find('select, input').not('[type="hidden"]').first();
			const $stagePage = $stageCountField.closest('.fui-page');

			// Formie disables the controls of inactive pages. Re-enabling this field
			// while its page is hidden makes both MutationObservers toggle the
			// `disabled` attribute forever and locks up the browser.
			if ($stagePage.is('[data-fui-page-hidden]')) {
				return;
			}

			$stageControl
				.prop('disabled', false)
				.prop('readonly', false)
				.removeAttr('disabled')
				.removeAttr('readonly')
				.attr('aria-disabled', 'false')
				.attr('tabindex', '0')
				.css({
					'width': '80px',
					'min-width': '80px',
					'max-width': '80px',
					'pointer-events': 'auto',
					'opacity': '1'
				});
			$stageControl.closest('.fui-input-wrapper').css({
				'width': '80px',
				'min-width': '80px',
				'max-width': '80px',
				'pointer-events': 'auto'
			});
		};
		enableStageCount();
		window.setTimeout(function() {
			replaceStageCountControl();
			enableStageCount();
		}, 100);
		window.setTimeout(function() {
			replaceStageCountControl();
			enableStageCount();
		}, 500);
		const updateArtistAssignments = function() {
			const stageCount = parseInt($stageCountField.find('select').val(), 10) || 1;
			const start = new Date(String($startDate.val() || '') + 'T00:00:00Z');
			const end = new Date(String($endDate.val() || '') + 'T00:00:00Z');
			const days = !isNaN(start) && !isNaN(end) && end >= start ? Math.round((end - start) / 86400000) + 1 : 0;
			$formieEncouragementForm.find('[data-field-handle="artistStage"] select, [data-field-handle$=".artistStage"] select, [data-field-handle="artistDay"] select, [data-field-handle$=".artistDay"] select').each(function() {
				const $select = $(this);
				const isDay = String($select.closest('[data-field-handle]').attr('data-field-handle')).split('.').pop() === 'artistDay';
				const value = String($select.val() || '');
				const limit = isDay ? days : stageCount;
				const options = [{value: '', label: isDay ? 'Sélectionner' : 'Pas encore attribué'}];
				for (let i = 1; i <= limit; i++) {
					options.push({value: String(i), label: isDay ? 'Jour ' + i : (i === 6 ? 'Scène 6 ou plus' : 'Scène ' + i)});
				}
				// Avoid resetting the select on every page event.
				const signature = JSON.stringify(options);
				if ($select.attr('data-assignment-options') !== signature) {
					$select.empty();
					options.forEach(function(option) { $select.append($('<option>', {value: option.value, text: option.label})); });
					$select.val(parseInt(value, 10) > limit ? '' : value).attr('data-assignment-options', signature);
				}
			});
		};
		updateArtistAssignments();
		$formieEncouragementForm.on('change input', '.encouragement-stage-count__select, [name="fields[eventStartDate]"], [name="fields[eventEndDate]"]', updateArtistAssignments);
		formieEncouragementForm.addEventListener('repeater:initRow', function() { window.setTimeout(updateArtistAssignments, 0); });
		formieEncouragementForm.addEventListener('onFormiePageToggle', function() { window.setTimeout(updateArtistAssignments, 0); });

		const budgetExpenseHandles = [
			'artistFees',
			'sacemFees',
			'artistTravel',
			'venueEquipment',
			'equipmentPurchase',
			'technicianFees',
			'insuranceFees',
			'roadPerDiem',
			'printingFees',
			'photoVideoFees',
			'marketingFees'
		];
		const budgetRevenueHandles = ['ownFunds', 'salesRevenue', 'subsidiesRevenue', 'sponsoringRevenue'];
		const findNestedFormieField = function(handle) {
			return $formieEncouragementForm.find('[data-field-handle="' + handle + '"], [data-field-handle$=".' + handle + '"]').first();
		};
		const $expenseBudget = findFormieField('expenseBudget', 'Dépenses');
		const $revenueBudget = findFormieField('revenueBudget', 'Recettes');

		if ($expenseBudget.length && $revenueBudget.length) {
			$expenseBudget.addClass('encouragement-budget-group encouragement-budget-group--expenses');
			$revenueBudget.addClass('encouragement-budget-group encouragement-budget-group--revenue');

			budgetExpenseHandles.concat(budgetRevenueHandles).forEach(function(handle) {
				findNestedFormieField(handle).addClass('encouragement-budget-amount');
			});
			findNestedFormieField('grantRequested').addClass('encouragement-budget-requested');
			findNestedFormieField('otherFunding').addClass('encouragement-budget-other');

			const $expenseTotal = $('<div class="encouragement-budget-total"><strong>Total dépenses</strong><strong data-formie-budget-total="expenses">0 €</strong></div>');
			const $revenueTotal = $('<div class="encouragement-budget-total"><strong>Total recettes</strong><strong data-formie-budget-total="revenue">0 €</strong></div>');
			const $budgetControls = $(
				'<div class="encouragement-budget-controls" aria-live="polite">' +
					'<p data-formie-budget-control="balance"><span aria-hidden="true"></span><span data-formie-budget-control-text></span></p>' +
				'</div>'
			);

			findNestedFormieField('marketingFees').closest('.fui-row').after($expenseTotal);
			findNestedFormieField('sponsoringRevenue').closest('.fui-row').after($revenueTotal, $budgetControls);

			const getBudgetAmount = function(handle) {
				const value = String(findNestedFormieField(handle).find('input').first().val() || '').replace(',', '.');
				return parseFloat(value) || 0;
			};
			const sumBudgetAmounts = function(handles) {
				return handles.reduce(function(total, handle) {
					return total + getBudgetAmount(handle);
				}, 0);
			};
			const formatBudgetAmount = function(value) {
				return new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2}).format(value) + ' €';
			};
			const setBudgetControl = function(name, isValid, text) {
				const $control = $budgetControls.find('[data-formie-budget-control="' + name + '"]');
				$control.toggleClass('is-valid', isValid).toggleClass('is-invalid', !isValid);
				$control.children('[aria-hidden="true"]').text(isValid ? '✓' : '×');
				if (text) {
					$control.find('[data-formie-budget-control-text]').text(text);
				}
			};
			const updateFormieBudget = function() {
				const expenses = sumBudgetAmounts(budgetExpenseHandles);
				const revenue = sumBudgetAmounts(budgetRevenueHandles);

				$expenseTotal.find('[data-formie-budget-total="expenses"]').text(formatBudgetAmount(expenses));
				$revenueTotal.find('[data-formie-budget-total="revenue"]').text(formatBudgetAmount(revenue));
				budgetIsBalanced = expenses > 0 && Math.round(expenses * 100) === Math.round(revenue * 100);
				updateBudgetContinueState();
				setBudgetControl('balance', budgetIsBalanced, 'Budget équilibré : dépenses (' + formatBudgetAmount(expenses) + ') = recettes (' + formatBudgetAmount(revenue) + ')');

			};

			$formieEncouragementForm.on('input change', '.encouragement-budget-amount input', updateFormieBudget);
			updateFormieBudget();
		}

		const findFormieSignatureField = function(handle) {
			let $field = $formieEncouragementForm.find('[data-field-handle="' + handle + '"], [data-field-handle$=".' + handle + '"]').first();
			if (!$field.length) {
				$field = $formieEncouragementForm.find('[name="fields[' + handle + ']"], [name*="[' + handle + ']"]').first().closest('.fui-field');
			}
			return $field;
		};
		let signatureSummaryInitialized = false;
		const initializeSignatureSummary = function() {
			if (signatureSummaryInitialized) {
				return;
			}
			const $signatureSummary = $formieEncouragementForm.find('.encouragement-signature-summary').first();
			const $signatureHint = $formieEncouragementForm.find('.encouragement-signature-hint').first();
			if (!$signatureSummary.length) {
				return;
			}
			const signatureSourceHandles = [
				'eventName',
				'eventLocation',
				'eventStartDate',
				'eventEndDate',
				'grantRequested'
			].concat(budgetExpenseHandles);
			const findSignatureField = function(handle) {
				return findFormieSignatureField(handle);
			};
			const getSignatureControl = function(handle) {
				let $control = $formieEncouragementForm.find('[name="fields[' + handle + ']"], [name^="fields[' + handle + ']["], [name*="[' + handle + ']"]').first();
				if (!$control.length) {
					$control = findSignatureField(handle).find('input, textarea, select').first();
				}
				return $control;
			};
			const getSignatureValue = function(handle) {
				const $control = getSignatureControl(handle);
				return signatureValueCache[handle] || ($control.length ? String($control.val() || '').trim() : '');
			};
			const rememberSignatureValues = function() {
				$formieEncouragementForm.find('input, textarea, select').each(function() {
					const $control = $(this);
					const fieldHandle = String($control.closest('[data-field-handle]').attr('data-field-handle') || '').split('.').pop();
					const name = String($control.attr('name') || '');
					const nameHandle = (name.match(/\[([^\]]+)\]/g) || []).map(function(value) {
						return value.slice(1, -1);
					}).find(function(value) {
						return signatureSourceHandles.indexOf(value) !== -1;
					});
					const handle = signatureSourceHandles.indexOf(fieldHandle) !== -1 ? fieldHandle : nameHandle;
					if (handle) {
						signatureValueCache[handle] = String($control.val() || '').trim();
					}
				});
			};
			const formatSignatureAmount = function(value) {
				return new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2}).format(value) + ' €';
			};
			const getFormieInputValue = function(handle) {
				return getSignatureValue(handle);
			};
			const getSignatureDate = function(handle) {
				return getSignatureValue(handle);
			};
			const updateSignatureSummary = function() {
				rememberSignatureValues();
				const $currentSignatureSummary = $('.organizersEncouragementPage__formie .encouragement-signature-summary').first();
				if (!$currentSignatureSummary.length) {
					return;
				}
				const eventName = getFormieInputValue('eventName') || '—';
				const eventLocation = getFormieInputValue('eventLocation');
				const startDate = getSignatureDate('eventStartDate') || '—';
				const endDate = getSignatureDate('eventEndDate') || '—';
				const start = new Date(startDate + 'T12:00:00');
				const end = new Date(endDate + 'T12:00:00');
				const days = startDate !== '—' && endDate !== '—' && !isNaN(start) && !isNaN(end) && end >= start
					? Math.floor((end - start) / 86400000) + 1
					: 0;
				const grant = parseFloat(getSignatureValue('grantRequested').replace(',', '.')) || 0;
				const expenses = budgetExpenseHandles.reduce(function(total, handle) {
					return total + (parseFloat(getSignatureValue(handle).replace(',', '.')) || 0);
				}, 0);
				$currentSignatureSummary.find('[data-encouragement-summary="event"]').text(eventName + (eventLocation ? ' — ' + eventLocation : ''));
				$currentSignatureSummary.find('[data-encouragement-summary="startDate"]').text(formatEncouragementDate(startDate));
				$currentSignatureSummary.find('[data-encouragement-summary="endDate"]').text(formatEncouragementDate(endDate));
				$currentSignatureSummary.find('[data-encouragement-summary="days"]').text(days);
				$currentSignatureSummary.find('[data-encouragement-summary="dayLabel"]').text(days === 1 ? 'jour' : 'jours');
				$currentSignatureSummary.find('[data-encouragement-summary="grant"]').text(formatSignatureAmount(grant));
				$currentSignatureSummary.find('[data-encouragement-summary="budget"]').text(formatSignatureAmount(expenses));
			};
			if ($signatureHint.length) {
				$signatureHint.text('Fait le ' + new Intl.DateTimeFormat('fr-FR').format(new Date()) + ' — la saisie de votre nom et la case ci-dessous valent signature électronique simple.');
			}
			$(document).on('input change', '.organizersEncouragementPage__formie .fui-form input, .organizersEncouragementPage__formie .fui-form textarea, .organizersEncouragementPage__formie .fui-form select', function() {
				rememberSignatureValues();
				updateSignatureSummary();
			});
			$(document).on('click', '.organizersEncouragementPage__formie .fui-form .fui-tab a, .organizersEncouragementPage__formie .fui-form .fui-next, .organizersEncouragementPage__formie .fui-form .fui-prev, .organizersEncouragementPage__formie .fui-form .fui-btn', function() {
				rememberSignatureValues();
				window.setTimeout(updateSignatureSummary, 0);
			});
			rememberSignatureValues();
			updateSignatureSummary();
			signatureSummaryInitialized = true;
		};
		initializeSignatureSummary();
		$formieEncouragementForm.on('onFormieThemeReady', function() {
			window.setTimeout(initializeSignatureSummary, 0);
		});
	}
	if ($encouragementForm.length) {
		const $panels = $encouragementForm.find('[data-encouragement-panel]');
		const $steps = $('[data-encouragement-step]');
		const $firstNextButton = $encouragementForm.find('[data-encouragement-panel="0"] [data-encouragement-next]');
		const $attestations = $encouragementForm.find('[name^="attestations["]');
		const $encouragementSubmit = $encouragementForm.find('[data-encouragement-submit]');
		let encouragementArtistCounter = 0;
		const updateEncouragementNextState = function() {
			$firstNextButton.prop('disabled', !$attestations.length || $attestations.filter(':checked').length !== $attestations.length);
		};
		const showEncouragementStep = function(step) {
			if (!$panels.filter('[data-encouragement-panel="' + step + '"]').length) {
				return;
			}
			$panels.each(function() {
				$(this).prop('hidden', String($(this).attr('data-encouragement-panel')) !== String(step));
			});
			$steps.removeClass('organizersEncouragementPage__step--active')
				.filter('[data-encouragement-step="' + step + '"]')
				.addClass('organizersEncouragementPage__step--active');
			window.scrollTo({top: $encouragementForm.offset().top - 32, behavior: 'smooth'});
		};
		const addEncouragementArtist = function() {
			const template = $encouragementForm.find('[data-encouragement-artist-template]')[0];
			const $artists = $encouragementForm.find('[data-encouragement-artists]');
			if (!template || !$artists.length) {
				return;
			}

			encouragementArtistCounter++;
			const $artist = $(template.content.cloneNode(true)).children();
			$artist.find('[data-encouragement-artist-title]').text('Artiste ' + encouragementArtistCounter);
			$artist.find('[data-encouragement-artist-field]').each(function() {
				const field = $(this).attr('data-encouragement-artist-field');
				const type = $(this).attr('type') || this.tagName.toLowerCase();
				$(this).attr('name', 'artists[' + encouragementArtistCounter + '][' + field + (type === 'checkbox' ? '][]' : ']'));
			});
			$artists.append($artist);
			updateEncouragementArtistStages();
			$artist.find('input[type="text"]').first().focus();
		};
		const updateEncouragementArtistStages = function() {
			const stageCount = parseInt($encouragementForm.find('[name="stageCount"]').val(), 10) || 1;

			$encouragementForm.find('[data-encouragement-artist-field="stage"]').each(function() {
				const $select = $(this);
				const selectedValue = $select.val();
				$select.empty().append($('<option>', {value: '', text: 'Pas encore attribué'}));
				for (let stage = 1; stage <= stageCount; stage++) {
					$select.append($('<option>', {value: String(stage), text: 'Scène ' + stage}));
				}
				if (selectedValue && parseInt(selectedValue, 10) <= stageCount) {
					$select.val(selectedValue);
				}
			});
		};
		const updateEncouragementDays = function() {
			const startValue = $encouragementForm.find('[data-encouragement-start-date]').val();
			const endValue = $encouragementForm.find('[data-encouragement-end-date]').val();
			let days = 0;

			if (startValue && endValue) {
				const start = new Date(startValue + 'T12:00:00');
				const end = new Date(endValue + 'T12:00:00');
				if (!isNaN(start.getTime()) && !isNaN(end.getTime()) && end >= start) {
					days = Math.floor((end - start) / 86400000) + 1;
				}
			}

			$encouragementForm.find('[data-encouragement-days]').text('Nombre total de jours : ' + days);
		};
		const updateEncouragementSummary = function() {
			const eventName = $encouragementForm.find('[name="eventName"]').val() || '—';
			const eventLocation = $encouragementForm.find('[name="eventLocation"]').val() || '—';
			const startDate = $encouragementForm.find('[data-encouragement-start-date]').val() || '—';
			const endDate = $encouragementForm.find('[data-encouragement-end-date]').val() || '—';
			let days = 0;

			if (startDate !== '—' && endDate !== '—') {
				const start = new Date(startDate + 'T12:00:00');
				const end = new Date(endDate + 'T12:00:00');
				if (!isNaN(start.getTime()) && !isNaN(end.getTime()) && end >= start) {
					days = Math.floor((end - start) / 86400000) + 1;
				}
			}

			$encouragementForm.find('[data-encouragement-summary="event"]').text([eventName, eventLocation].filter(function(value) { return value !== '—'; }).join(' — ') || '—');
			$encouragementForm.find('[data-encouragement-summary="startDate"]').text(startDate);
			$encouragementForm.find('[data-encouragement-summary="endDate"]').text(endDate);
			$encouragementForm.find('[data-encouragement-summary="days"]').text(days);
		};
		const updateEncouragementBudgetTotals = function() {
			const totals = {};
			['expenses', 'revenue'].forEach(function(group) {
				let total = 0;
				$encouragementForm.find('input[name^="budget' + (group === 'expenses' ? 'Expenses' : 'Revenue') + '["]:not(:disabled)').each(function() {
					const value = parseFloat(String($(this).val()).replace(',', '.'));
					if (!isNaN(value)) {
						total += value;
					}
				});
				totals[group] = total;
				$encouragementForm.find('[data-encouragement-budget-total="' + group + '"]').text(new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2}).format(total) + ' €');
			});
			const grant = parseFloat(String($encouragementForm.find('[name="budgetRevenue[grant]"]').val()).replace(',', '.')) || 0;
			$encouragementForm.find('[data-encouragement-summary="grant"]').text(new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2}).format(grant) + ' €');
			$encouragementForm.find('[data-encouragement-summary="budget"]').text(new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2}).format(totals.expenses || 0) + ' €');
		};
		const updateEncouragementSubmitState = function() {
			const hasSignerName = String($encouragementForm.find('[name="signerName"]').val() || '').trim().length > 0;
			const hasCertification = $encouragementForm.find('[name="signatureCertification"]').is(':checked');
			$encouragementSubmit.prop('disabled', !hasSignerName || !hasCertification);
		};

		$encouragementForm.on('click', '[data-encouragement-next]', function() {
			const currentStep = parseInt($panels.filter(':not([hidden])').first().attr('data-encouragement-panel'), 10) || 0;
			if (currentStep === 0 && (!$attestations.length || $attestations.filter(':checked').length !== $attestations.length)) {
				return;
			}
			showEncouragementStep(currentStep + 1);
		});
		$encouragementForm.on('click', '[data-encouragement-previous]', function() {
			const currentStep = parseInt($panels.filter(':not([hidden])').first().attr('data-encouragement-panel'), 10) || 0;
			showEncouragementStep(Math.max(0, currentStep - 1));
		});
		$encouragementForm.on('click', '[data-encouragement-add-artist]', addEncouragementArtist);
		$encouragementForm.on('click', '[data-encouragement-remove-artist]', function() {
			$(this).closest('[data-encouragement-artist]').remove();
		});
		$encouragementForm.on('change', '[name="stageCount"]', updateEncouragementArtistStages);
		$encouragementForm.on('input change', '[data-encouragement-start-date], [data-encouragement-end-date]', updateEncouragementDays);
		$encouragementForm.on('input change', '[name="eventName"], [name="eventLocation"], [data-encouragement-start-date], [data-encouragement-end-date]', updateEncouragementSummary);
		$encouragementForm.on('input', 'input[name^="budgetExpenses["], input[name^="budgetRevenue["]', updateEncouragementBudgetTotals);
		$encouragementForm.on('change', '[name^="attestations["]', updateEncouragementNextState);
		$encouragementForm.on('input change', '[name="signerName"], [name="signatureCertification"]', updateEncouragementSubmitState);
		updateEncouragementNextState();
		updateEncouragementDays();
		updateEncouragementSummary();
		updateEncouragementBudgetTotals();
		updateEncouragementSubmitState();
	}

	// -- bilan totals --
	const $bilanForm = $('.organizersBilanPage__form, .organizersBilanPage__formie .fui-form');
	if ($bilanForm.length) {
		const formatBilanAmount = function(amount) {
			return new Intl.NumberFormat('fr-FR', {
				maximumFractionDigits: 2
			}).format(amount) + ' €';
		};
		const updateBilanTotal = function(group) {
			let total = 0;

			const legacySelector = 'input[name^="' + group + '["]:not(:disabled)';
			const formiePrefix = group === 'expenses' ? 'expense' : 'revenue';
			const formieSelector = '[data-field-handle^="' + formiePrefix + '"] input:not(:disabled)';
			const customFormieSelector = 'input[name^="fields[' + formiePrefix + ']"]:not(:disabled)';
			$bilanForm.find(legacySelector + ', ' + formieSelector + ', ' + customFormieSelector).each(function() {
				const value = parseFloat(String($(this).val()).replace(',', '.'));
				if (!isNaN(value)) {
					total += value;
				}
			});

			$bilanForm.find('[data-bilan-total="' + group + '"] strong').text(formatBilanAmount(total));
		};
		const updateBilanTotals = function() {
			updateBilanTotal('expenses');
			updateBilanTotal('revenues');
		};
		const $bilanSubmit = $bilanForm.find('.organizersBilanPage__submit');
		const updateBilanSubmitState = function() {
			const prefix = $bilanForm.find('[name^="fields["]').length ? 'fields[' : '';
			const fieldName = function(handle) {
				return prefix ? '[name="fields[' + handle + ']"]' : '[name="' + handle + '"]';
			};
			const hasRequiredChecks = ['requiredElements', 'accurateInformation']
				.every(function(handle) { return $bilanForm.find(fieldName(handle)).is(':checked'); });
			const hasHonorCertification = $bilanForm.find(fieldName('honorCertification')).is(':checked');
			const hasSignerName = String($bilanForm.find(fieldName('signerName')).val() || '').trim().length > 0;
			$bilanSubmit.prop('disabled', !hasRequiredChecks || !hasHonorCertification || !hasSignerName);
		};

		updateBilanTotals();
		updateBilanSubmitState();
		$bilanForm.on('input change', 'input[name^="expenses["], input[name^="revenues["], input[name^="fields[expense"], input[name^="fields[revenue"]', updateBilanTotals);
		$bilanForm.on('input change', '[name^="fields["], [name="signerName"], [name="honorCertification"]', updateBilanSubmitState);
	}

	// -- charter validation --
	const $charterForm = $('.charterModal__form');
	if ($charterForm.length) {
		const $charterCheckbox = $charterForm.find('input[name="acceptCharter"]');
		const $charterSubmit = $charterForm.find('.charterModal__submit');
		const setCharterSubmitState = function() {
			$charterSubmit.prop('disabled', !$charterCheckbox.is(':checked'));
		};

		setCharterSubmitState();
		$charterCheckbox.on('change', setCharterSubmitState);
	}

	let $lastCharterTrigger = null;
	const openCharterModal = function($modal) {
		if (!$modal.length) {
			return;
		}

		$modal.removeAttr('hidden').attr('aria-hidden', 'false');

		const $focusTarget = $modal.find('[data-charter-modal-close], button, a, input').filter(':visible').first();
		if ($focusTarget.length) {
			$focusTarget.focus();
		}
	};
	const closeCharterModal = function($modal) {
		if (!$modal.length || $modal.attr('data-closable') !== 'true') {
			return;
		}

		$modal.attr({
			hidden: true,
			'aria-hidden': 'true'
		});

		if ($lastCharterTrigger && $lastCharterTrigger.length) {
			$lastCharterTrigger.focus();
		}
	};

	$(document).on('click', '[data-charter-modal-open]', function(e) {
		e.preventDefault();
		$lastCharterTrigger = $(this);
		openCharterModal($('#' + $(this).attr('data-charter-modal-open')));
	});

	$(document).on('click', '[data-charter-modal-close]', function(e) {
		e.preventDefault();
		closeCharterModal($(this).closest('.charterModal'));
	});

	// -- programming modal --
	let $lastProgrammingTrigger = null;
	const openProgrammingModal = function($modal) {
		if (!$modal.length) {
			return;
		}

		$modal.removeAttr('hidden').attr('aria-hidden', 'false');
		$('body').addClass('programmingModalIsOpen');

		const $focusTarget = $modal.find('form input:not([type="hidden"]), form select, form textarea, form button').filter(':visible').first();
		if ($focusTarget.length) {
			$focusTarget.focus();
		}
	};
	const closeProgrammingModal = function($modal) {
		if (!$modal.length) {
			return;
		}

		$modal.attr({
			hidden: true,
			'aria-hidden': 'true'
		});

		if (!$('.programmingModal:not([hidden])').length) {
			$('body').removeClass('programmingModalIsOpen');
		}

		if ($lastProgrammingTrigger && $lastProgrammingTrigger.length) {
			$lastProgrammingTrigger.focus();
		}
	};
	const resetProgrammingArtists = function($modal) {
		const $artistRow = $modal.find('[data-programming-artist-row]').first();
		const $socialRows = $modal.find('[data-programming-social-rows]').first();

		$socialRows.find('[data-programming-social-row]').not(':first').remove();

		$artistRow.find('[data-programming-field="artistName"]').val('');
		$artistRow.find('[data-programming-field="genreId"]').val('');
		$modal.find('[data-programming-field="socialMedia"]').val('');
		$modal.find('[data-programming-field="socialHref"]').val('');
		$socialRows.find('[data-programming-social-remove]').attr('hidden', true);
	};
	const resetProgrammingModal = function($modal) {
		const form = $modal.find('form')[0];
		if (form) {
			form.reset();
		}

		resetProgrammingArtists($modal);
		$modal.find('[data-programming-field="eventId"]').val('');
	};
	const populateProgrammingModal = function($trigger, $modal) {
		if (!$modal.length) {
			return;
		}

		resetProgrammingModal($modal);

		const eventId = $trigger.attr('data-programming-event-id');
		if (!eventId) {
			return;
		}

		$modal.find('[data-programming-field="eventId"]').val(eventId);
		$modal.find('[data-programming-field="artistName"]').val($trigger.attr('data-programming-event-title') || '');
		$modal.find('[data-programming-field="genreId"]').val($trigger.attr('data-programming-event-genre-id') || '');
		$modal.find('[data-programming-field="socialMedia"]').val($trigger.attr('data-programming-event-social-media') || '');
		$modal.find('[data-programming-field="socialHref"]').val($trigger.attr('data-programming-event-social-href') || '');
		const $genre = $modal.find('[data-programming-field="genreId"]');
		if ($genre.data('nice-select')) {
			$genre.niceSelect('update');
		}
		const $socialMedia = $modal.find('[data-programming-field="socialMedia"]');
		if ($socialMedia.data('nice-select')) {
			$socialMedia.niceSelect('update');
		}
		$modal.find('[data-programming-field="eventDate"]').val($trigger.attr('data-programming-event-date') || '');
		$modal.find('[data-programming-field="eventStartTime"]').val($trigger.attr('data-programming-event-start-time') || '');
		$modal.find('[data-programming-field="eventEndTime"]').val($trigger.attr('data-programming-event-end-time') || '');

		const $scene = $modal.find('[data-programming-field="sceneId"]');
		$scene.val($trigger.attr('data-programming-event-scene-id') || '');
		if ($scene.data('nice-select')) {
			$scene.niceSelect('update');
		}
	};
	$(document).on('click', '[data-programming-modal-open]', function(e) {
		e.preventDefault();
		$lastProgrammingTrigger = $(this);
		const $modal = $('#' + $(this).attr('data-programming-modal-open'));
		populateProgrammingModal($(this), $modal);
		openProgrammingModal($modal);
	});

	$(document).on('click', '[data-programming-modal-close]', function(e) {
		e.preventDefault();
		closeProgrammingModal($(this).closest('.programmingModal'));
	});

	// -- organizer scenes modal --
	let $lastScenesTrigger = null;
	const openScenesModal = function($modal) {
		if (!$modal.length) {
			return;
		}

		resetSceneForm($modal);
		$modal.find('[data-programming-scenes-feedback]')
			.text('')
			.removeClass('is-error')
			.attr('hidden', true);
		$modal.removeAttr('hidden').attr('aria-hidden', 'false');
		$('body').addClass('programmingModalIsOpen');
		const $focusTarget = $modal.find('input, button').filter(':visible').first();
		if ($focusTarget.length) {
			$focusTarget.focus();
		}
	};
	const closeScenesModal = function($modal) {
		if (!$modal.length) {
			return;
		}

		$modal.attr({hidden: true, 'aria-hidden': 'true'});
		if (!$('.programmingModal:not([hidden])').length) {
			$('body').removeClass('programmingModalIsOpen');
		}
		if ($lastScenesTrigger && $lastScenesTrigger.length) {
			$lastScenesTrigger.focus();
		}
	};

	$(document).on('click', '[data-programming-scenes-open]', function(e) {
		e.preventDefault();
		$lastScenesTrigger = $(this);
		openScenesModal($('#' + $(this).attr('data-programming-scenes-open')));
	});

	$(document).on('click', '[data-programming-scenes-close]', function(e) {
		e.preventDefault();
		closeScenesModal($(this).closest('.programmingModal'));
	});

	$(document).on('click', '[data-programming-scene-edit]', function() {
		const $button = $(this);
		const $modal = $button.closest('.programmingModal');
		$modal.find('[data-programming-scene-id]').val($button.attr('data-scene-id') || '');
		$modal.find('[data-programming-scene-name]').val($button.attr('data-scene-title') || '').focus();
		$modal.find('[data-programming-scene-submit]').text('Enregistrer la scène');
		$modal.find('[data-programming-scene-form-title]').text('Modifier la scène');
		$modal.find('[data-programming-scene-new]').removeAttr('hidden');
	});

	$(document).on('click', '[data-programming-scene-new]', function() {
		const $modal = $(this).closest('.programmingModal');
		$modal.find('[data-programming-scene-id]').val('');
		$modal.find('[data-programming-scene-name]').val('').focus();
		$modal.find('[data-programming-scene-submit]').text('Ajouter la scène');
		$modal.find('[data-programming-scene-form-title]').text('Ajouter une scène');
		$(this).attr('hidden', true);
	});

	const showScenesFeedback = function($modal, message, isError) {
		const $feedback = $modal.find('[data-programming-scenes-feedback]');
		$feedback.text(message).toggleClass('is-error', !!isError).removeAttr('hidden');
	};
	const resetSceneForm = function($modal) {
		$modal.find('[data-programming-scene-id]').val('');
		$modal.find('[data-programming-scene-name]').val('');
		$modal.find('[data-programming-scene-submit]').text('Ajouter la scène');
		$modal.find('[data-programming-scene-form-title]').text('Ajouter une scène');
		$modal.find('[data-programming-scene-new]').attr('hidden', true);
	};
	const addSceneRow = function($modal, scene) {
		const $list = $modal.find('[data-programming-scenes-list]');
		const $row = $('<div>', {class: 'organizersScenesModal__row', 'data-programming-scene-row': true, 'data-scene-id': scene.id});
		const $actions = $('<div>', {class: 'organizersScenesModal__rowActions'});
		const $edit = $('<button>', {type: 'button', class: 'organizersScenesModal__edit', 'data-programming-scene-edit': true, 'data-scene-id': scene.id}).text('Modifier');
		$edit.attr('data-scene-title', scene.title);
		const $deleteForm = $('<form>', {method: 'post', 'data-programming-scene-delete-form': true});
		const $sourceForm = $modal.find('[data-programming-scene-form]');
		const csrfName = $sourceForm.find('input[name^="CRAFT_CSRF_TOKEN"]').attr('name');
		const csrfValue = $sourceForm.find('input[name^="CRAFT_CSRF_TOKEN"]').val();
		if (csrfName) {
			$deleteForm.append($('<input>', {type: 'hidden', name: csrfName, value: csrfValue}));
		}
		$deleteForm.append($('<input>', {type: 'hidden', name: 'action', value: 'organizersmodule/events/delete-scene'}));
		$deleteForm.append($('<input>', {type: 'hidden', name: 'organizerEntryId', value: $sourceForm.find('[name="organizerEntryId"]').val()}));
		$deleteForm.append($('<input>', {type: 'hidden', name: 'sceneId', value: scene.id}));
		$deleteForm.append($('<button>', {type: 'submit', class: 'organizersScenesModal__delete'}).text('Supprimer'));
		$row.append($('<span>').text(scene.title), $actions.append($edit, $deleteForm));
		$list.append($row);
		$modal.find('[data-programming-scenes-empty]').attr('hidden', true);
	};
	const syncSceneOptions = function(scene) {
		$('[data-programming-field="sceneId"], [data-programming-full-scene-select]').each(function() {
			const $select = $(this);
			let $option = $select.find('option[value="' + scene.id + '"]');
			if ($option.length) {
				$option.text(scene.label || scene.title);
			} else {
				$select.append($('<option>', {value: scene.id}).text(scene.label || scene.title));
			}
			if ($select.data('nice-select')) {
				$select.niceSelect('update');
			}
		});
	};
	const removeSceneOptions = function(sceneId) {
		$('[data-programming-field="sceneId"], [data-programming-full-scene-select]').each(function() {
			const $select = $(this);
			$select.find('option[value="' + sceneId + '"]').remove();
			if ($select.data('nice-select')) {
				$select.niceSelect('update');
			}
		});
	};

	$(document).on('submit', '[data-programming-scene-form]', function(e) {
		e.preventDefault();
		const $form = $(this);
		const $modal = $form.closest('.programmingModal');
		const sceneId = $form.find('[data-programming-scene-id]').val();
		const formData = new FormData(this);
		fetch(window.location.href, {
			method: 'POST',
			body: formData,
			headers: {'X-Requested-With': 'XMLHttpRequest'},
			credentials: 'same-origin',
		})
			.then(response => response.json())
			.then(data => {
				if (!data.success) {
					showScenesFeedback($modal, data.message || 'La scène n’a pas pu être enregistrée.', true);
					return;
				}

				const $row = $modal.find('[data-programming-scene-row][data-scene-id="' + data.scene.id + '"]');
				if ($row.length) {
					$row.find('> span').text(data.scene.title);
					$row.find('[data-programming-scene-edit]').attr('data-scene-title', data.scene.title);
				} else {
					addSceneRow($modal, data.scene);
				}
				syncSceneOptions(data.scene);
				resetSceneForm($modal);
				showScenesFeedback($modal, data.message, false);
			})
			.catch(() => showScenesFeedback($modal, 'Une erreur est survenue. Veuillez réessayer.', true));
	});

	$(document).on('submit', '[data-programming-scene-delete-form]', function(e) {
		e.preventDefault();
		if (!window.confirm('Êtes-vous sûr·e de vouloir supprimer cette scène ?')) {
			return;
		}
		const $form = $(this);
		const $modal = $form.closest('.programmingModal');
		fetch(window.location.href, {
			method: 'POST',
			body: new FormData(this),
			headers: {'X-Requested-With': 'XMLHttpRequest'},
			credentials: 'same-origin',
		})
			.then(response => response.json())
			.then(data => {
				if (!data.success) {
					showScenesFeedback($modal, data.message || 'La scène n’a pas pu être supprimée.', true);
					return;
				}

				$modal.find('[data-programming-scene-row][data-scene-id="' + data.sceneId + '"]').remove();
				removeSceneOptions(data.sceneId);
				if (!$modal.find('[data-programming-scene-row]').length) {
					$modal.find('[data-programming-scenes-empty]').removeAttr('hidden');
				}
				showScenesFeedback($modal, data.message, false);
			})
			.catch(() => showScenesFeedback($modal, 'Une erreur est survenue. Veuillez réessayer.', true));
	});

	$(document).on('click', '[data-programming-social-add]', function() {
		const $button = $(this);
		const $modal = $button.closest('.programmingModal');
		const $rows = $modal.find('[data-programming-social-rows]').first();
		const template = $modal.find('[data-programming-social-template]').html();

		if (!template) {
			return;
		}

		const key = 'new' + ($rows.find('[data-programming-social-row]').length + 1);
		$rows.append(template.replace(/__KEY__/g, key));
		$rows.find('[data-programming-social-remove]').removeAttr('hidden');
	});

	$(document).on('click', '[data-programming-social-remove]', function() {
		const $rows = $(this).closest('[data-programming-social-rows]');
		$(this).closest('[data-programming-social-row]').remove();
		if ($rows.find('[data-programming-social-row]').length === 1) {
			$rows.find('[data-programming-social-remove]').attr('hidden', true);
		}
	});

	$(document).on('submit', '[data-programming-finalize-form]', function(e) {
		if (!window.confirm('Êtes-vous sûr·e de vouloir verrouiller votre programmation ? Une fois verrouillée, vous ne pourrez plus la modifier à moins de prendre contact avec l’organisation.')) {
			e.preventDefault();
		}
	});

	$(document).on('keydown', function(e) {
		if (e.key === 'Escape' || e.key === 'Esc') {
			closeCharterModal($('.charterModal:not([hidden])'));
			closeProgrammingModal($('.programmingModal:not([hidden])'));
			closeScenesModal($('.organizersScenesModal:not([hidden])'));
		}
	});

	// -- full programming page --
	const $programmingFullForm = $('[data-programming-full-form]');
	if ($programmingFullForm.length && $programmingFullForm.attr('data-programming-locked') !== 'true') {
		let programmingFullCounter = 0;
		const dayLabels = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
		const nextProgrammingKey = function(prefix) {
			programmingFullCounter++;
			return prefix + '-' + Date.now() + '-' + programmingFullCounter;
		};
		const templateHtml = function(selector, replacements) {
			let html = $(selector).html() || '';
			$.each(replacements, function(key, value) {
				html = html.split(key).join(value);
			});

			return html;
		};
		const updateSceneNumbers = function() {
			$programmingFullForm.find('[data-programming-full-scene]').each(function(index) {
				$(this).find('.organizersProgrammingPage__sceneBadge').first().text('Scène ' + (index + 1));
			});
		};
		const updateSlotSceneFields = function($scene) {
			const $sceneSelect = $scene.find('[data-programming-full-scene-select]');
			const selectedSceneId = $sceneSelect.length ? $sceneSelect.val() : '';
			const sceneId = selectedSceneId || $scene.attr('data-programming-scene-id') || '';
			$scene.attr('data-programming-scene-id', sceneId);
			$scene.find('[data-programming-full-scene-field]').val(sceneId);
		};
		const updateSlotDay = function($slot) {
			const value = $slot.find('[data-programming-full-date]').val();
			const date = value ? new Date(value + 'T12:00:00') : null;
			const label = date && !isNaN(date.getTime()) ? dayLabels[date.getDay()] : 'Jour';
			$slot.find('[data-programming-full-day]').text(label);
		};
		const appendDeletedEventId = function(eventId) {
			if (!eventId) {
				return;
			}

			$programmingFullForm.find('[data-programming-full-deleted]').append(
				$('<input>', {
					type: 'hidden',
					name: 'deletedEventIds[]',
					value: eventId
				})
			);
		};
		const markDeletedSlot = function($slot) {
			appendDeletedEventId($slot.attr('data-event-id'));
		};
		const addFullProgrammingSlot = function($scene) {
			const slotKey = nextProgrammingKey('slot');
			const $slot = $(templateHtml('[data-programming-full-slot-template]', {
				'__SLOT_KEY__': slotKey
			}));

			$scene.find('[data-programming-full-slots]').append($slot);
			updateSlotSceneFields($scene);
			updateSlotDay($slot);
			$slot.find('[data-programming-full-date]').focus();
		};

		$(document).on('change', '[data-programming-full-scene-select]', function() {
			updateSlotSceneFields($(this).closest('[data-programming-full-scene]'));
		});

		$(document).on('change', '[data-programming-full-date]', function() {
			updateSlotDay($(this).closest('[data-programming-full-slot]'));
		});

		$(document).on('click', '[data-programming-full-add-slot]', function(e) {
			e.preventDefault();
			addFullProgrammingSlot($(this).closest('[data-programming-full-scene]'));
		});

		$(document).on('click', '[data-programming-full-add-scene]', function(e) {
			e.preventDefault();
			const $scene = $(templateHtml('[data-programming-full-scene-template]', {}));
			$programmingFullForm.find('[data-programming-full-scenes]').append($scene);
			updateSceneNumbers();
			$scene.find('[data-programming-full-scene-select]').focus();
		});

		$(document).on('click', '[data-programming-full-remove-slot]', function(e) {
			e.preventDefault();
			const $slot = $(this).closest('[data-programming-full-slot]');
			markDeletedSlot($slot);
			$slot.remove();
		});

		$(document).on('click', '[data-programming-full-remove-scene]', function(e) {
			e.preventDefault();
			const $scene = $(this).closest('[data-programming-full-scene]');
			$scene.find('[data-programming-full-slot]').each(function() {
				markDeletedSlot($(this));
			});
			$scene.remove();
			updateSceneNumbers();
		});
	}

	// -- profile page --
	let profileSaveStatusTimer = null;
	const initLocalityAutocomplete = function() {
		const $autocomplete = $('[data-locality-autocomplete]');
		if (!$autocomplete.length || $autocomplete.data('locality-initialized')) {
			return;
		}

		$autocomplete.data('locality-initialized', true);
		const $input = $autocomplete.find('[data-locality-input]');
		const $suggestions = $autocomplete.find('[data-locality-suggestions]');
		const $options = $suggestions.find('[data-locality-option]');

		const hideSuggestions = function() {
			$options.prop('hidden', true);
			$suggestions.prop('hidden', true);
		};
		const updateSuggestions = function() {
			const query = $.trim($input.val()).toLocaleLowerCase();
			let visibleCount = 0;

			$options.each(function() {
				const $option = $(this);
				const matches = query.length > 0 && $option.attr('data-locality-option').toLocaleLowerCase().indexOf(query) !== -1;
				$option.prop('hidden', !matches);
				if (matches) {
					visibleCount++;
				}
			});

			$suggestions.prop('hidden', visibleCount === 0);
		};

		$input.on('input.locality focus.locality', updateSuggestions);
		$input.on('keydown.locality', function(e) {
			if (e.key === 'Escape' || e.key === 'Esc') {
				hideSuggestions();
			}
		});
		$options.on('click.locality', function() {
			$input.val($(this).attr('data-locality-option')).trigger('change');
			hideSuggestions();
			$input.focus();
		});
		$(document).on('click.locality', function(e) {
			if (!$(e.target).closest('[data-locality-autocomplete]').length) {
				hideSuggestions();
			}
		});
	};

	initLocalityAutocomplete();

	const initProfileForm = function($profileForm) {
		if (!$profileForm.length || $profileForm.data('profile-initialized')) {
			return;
		}

		$profileForm.data('profile-initialized', true);

		const $bankFields = $profileForm.find('[data-profile-bank-field]');
		const $ribConfirmation = $profileForm.find('#organizerRibConfirmed');
		const $ribConfirmedAt = $profileForm.find('[data-profile-rib-confirmed-at]');
		const $ribConfirmationText = $profileForm.find('[data-profile-rib-confirmation-text]');
		const $ribFileInput = $profileForm.find('[data-profile-file-input]');
		const $profileSubmit = $profileForm.find('[data-profile-submit]');
		const updateRibConfirmationState = function() {
			const bankDetailsComplete = $bankFields.length === 3 && $bankFields.toArray().every(function(field) {
				return $.trim($(field).val()) !== '';
			});
			const ribUploaded = $ribFileInput[0] && $ribFileInput[0].files && $ribFileInput[0].files.length;
			const existingRib = $profileForm.find('[data-rib-existing-file]').length && !$profileForm.find('[data-rib-existing-file]').prop('disabled');
			const canConfirm = bankDetailsComplete && (ribUploaded || existingRib);

			$ribConfirmation.prop('disabled', !canConfirm);
			$ribConfirmationText.toggleClass('is-disabled', !canConfirm);
		};
		const resetRibConfirmation = function() {
			$ribConfirmation.prop('checked', false);
			updateRibConfirmationState();
		};

		updateRibConfirmationState();
		$bankFields.on('input.profile', resetRibConfirmation);
		$ribFileInput.on('change.profile', function() {
			const file = this.files && this.files.length ? this.files[0] : null;
			if (file) {
				updateProfileRibFile($(this), file);
			}
			resetRibConfirmation();
			updateRibConfirmationState();
		});

		$profileForm.on('input.profile change.profile', 'input, select, textarea', function() {
			hideProfileSaveStatus($profileForm);
		});

		$profileForm.on('submit.profile', function(e) {
			e.preventDefault();

			const $form = $(this);
			prepareProfileFormValues($form);
			$profileSubmit.prop('disabled', true);
			showProfileSaveStatus($form, 'Enregistrement...', false, false);

			$.ajax({
				type: 'POST',
				url: profileSubmitUrl($form),
				dataType: 'json',
				data: new FormData(this),
				contentType: false,
				processData: false,
				headers: {
					Accept: 'application/json',
				},
				success: function() {
					refreshProfileForm($form, '✓ Profil enregistré');
				},
				error: function(xhr) {
					$profileSubmit.prop('disabled', false);
					showProfileSaveStatus($form, firstProfileError(xhr), true);
				}
			});
		});
	};

	initProfileForm($('.organizersProfile__form'));

	const prepareProfileFormValues = function($form) {
		const structureName = $form.find('[data-profile-structure-name]').val();
		const contactPhone = $form.find('[data-profile-contact-phone]').val();
		const $ribConfirmation = $form.find('#organizerRibConfirmed');
		const $ribConfirmedAt = $form.find('[data-profile-rib-confirmed-at]');
		const currentYear = String(new Date().getFullYear());

		if ($ribConfirmation.is(':checked')) {
			if (!$ribConfirmedAt.val() || $ribConfirmedAt.val().slice(0, 4) !== currentYear) {
				const now = new Date();
				const pad = function(value) {
					return String(value).padStart(2, '0');
				};

				$ribConfirmedAt.val(
					currentYear + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate()) + ' ' +
					pad(now.getHours()) + ':' + pad(now.getMinutes()) + ':' + pad(now.getSeconds())
				);
			}
		} else {
			$ribConfirmedAt.val('');
		}

		$form.find('[data-profile-full-name]').val(structureName);
		$form.find('[data-profile-phone]').val(contactPhone);
	};

	const profileSubmitUrl = function($form) {
		const action = $form.attr('action');

		return action && action !== '#' ? action : window.location.href;
	};

	const showProfileSaveStatus = function($form, message, isError, autoHide) {
		const $status = $form.find('[data-profile-save-status]');
		if (!$status.length) {
			return;
		}

		if (profileSaveStatusTimer) {
			clearTimeout(profileSaveStatusTimer);
			profileSaveStatusTimer = null;
		}

		$status
			.text(message)
			.prop('hidden', false)
			.toggleClass('is-error', !!isError)
			.toggleClass('is-success', !isError);

		if (autoHide !== false) {
			profileSaveStatusTimer = setTimeout(function() {
				hideProfileSaveStatus($form);
			}, isError ? 6000 : 4000);
		}
	};

	const hideProfileSaveStatus = function($form) {
		const $status = $form.find('[data-profile-save-status]');
		if (!$status.length) {
			return;
		}

		if (profileSaveStatusTimer) {
			clearTimeout(profileSaveStatusTimer);
			profileSaveStatusTimer = null;
		}

		$status.prop('hidden', true).text('').removeClass('is-error is-success');
	};

	const refreshProfileForm = function($form, message) {
		$.ajax({
			type: 'GET',
			url: window.location.href,
			dataType: 'html',
			cache: false,
			success: function(html) {
				const $updatedForm = $('<div>').append($.parseHTML(html, document, true)).find('.organizersProfile__form').first();
				if (!$updatedForm.length) {
					$form.find('[data-profile-submit]').prop('disabled', false);
					showProfileSaveStatus($form, message, false, false);
					return;
				}

				$form.replaceWith($updatedForm);
				initProfileForm($updatedForm);
				showProfileSaveStatus($updatedForm, message, false, false);
			},
			error: function() {
				$form.find('[data-profile-submit]').prop('disabled', false);
				showProfileSaveStatus($form, message, false, false);
			}
		});
	};

	const firstProfileError = function(xhr) {
		const response = xhr && xhr.responseJSON ? xhr.responseJSON : {};
		const errors = response.errors || {};
		const findMessage = function(value) {
			if (!value) {
				return '';
			}
			if (typeof value === 'string') {
				return value;
			}
			if ($.isArray(value)) {
				for (let index = 0; index < value.length; index++) {
					const message = findMessage(value[index]);
					if (message) {
						return message;
					}
				}
			}
			if (typeof value === 'object') {
				for (const key in value) {
					if (Object.prototype.hasOwnProperty.call(value, key)) {
						const message = findMessage(value[key]);
						if (message) {
							return message;
						}
					}
				}
			}

			return '';
		};

		return findMessage(errors) || response.message || "Le profil n'a pas pu être enregistré.";
	};

	const isPdfFile = function(file) {
		return file && (file.type === 'application/pdf' || /\.pdf$/i.test(file.name));
	};

	const formatProfileFileSize = function(bytes) {
		const size = parseInt(bytes, 10) || 0;
		if (size >= 1048576) {
			return new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 1}).format(size / 1048576) + ' Mo';
		}

		return new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0}).format(size / 1024) + ' Ko';
	};

	const updateProfileRibFile = function($input, file) {
		const $section = $input.closest('.organizersProfile__bank');
		const $dropzone = $section.find('.organizersProfile__dropzone');
		const $ribFile = $section.find('[data-profile-rib-file]');
		const $uploadText = $section.find('[data-profile-upload-text]');
		const $ribFileMeta = $section.find('[data-profile-rib-file-meta]');
		const $ribDownload = $section.find('[data-profile-rib-download]');

		if (!isPdfFile(file)) {
			$input.val('');
			$section.find('[data-rib-existing-file]').prop('disabled', false);
			$dropzone.removeClass('is-dragover is-uploaded').addClass('is-error');
			$ribFile.removeClass('is-pending').addClass('is-error');
			$ribDownload.removeClass('is-disabled').removeAttr('aria-disabled tabindex');
			if ($ribFile.length) {
				$uploadText.text($ribFile.attr('data-profile-rib-original-name') || 'Fichier invalide');
				$ribFileMeta.text('Veuillez déposer un fichier PDF');
			} else {
				$uploadText.text('Veuillez déposer un fichier PDF');
			}
			return;
		}

		$input[0].setCustomValidity('');
		$section.find('[data-rib-existing-file]').prop('disabled', true);
		$dropzone.removeClass('is-dragover is-error').addClass('is-uploaded');
		$ribFile.removeClass('is-error').addClass('is-pending');
		$uploadText.text(file.name + ($dropzone.length ? ' déposé' : ''));
		$ribFileMeta.text('PDF · ' + formatProfileFileSize(file.size) + ' · à enregistrer');
		$ribDownload.addClass('is-disabled').attr({
			'aria-disabled': 'true',
			tabindex: '-1'
		});
	};

	const setProfileRibDropError = function($input, message) {
		const $section = $input.closest('.organizersProfile__bank');
		const $dropzone = $section.find('.organizersProfile__dropzone');
		const $uploadText = $section.find('[data-profile-upload-text]');

		$dropzone.removeClass('is-dragover is-uploaded').addClass('is-error');
		$uploadText.text(message);
	};

	$(document).on('click', '[data-profile-rib-download][aria-disabled="true"]', function(e) {
		e.preventDefault();
	});

	$(document).on('keydown', '[data-profile-rib-replace]', function(e) {
		if (e.key !== 'Enter' && e.key !== ' ') {
			return;
		}

		e.preventDefault();
		$('#' + $(this).attr('for')).trigger('click');
	});

	const assignProfileRibDropFile = function(input, file) {
		try {
			const dataTransfer = new DataTransfer();
			dataTransfer.items.add(file);
			input.files = dataTransfer.files;
		} catch (error) {
			return false;
		}

		return input.files && input.files.length && input.files[0].name === file.name;
	};

	$(document).on('dragenter dragover', '[data-profile-dropzone]', function(e) {
		e.preventDefault();
		e.stopPropagation();

		if (e.originalEvent.dataTransfer) {
			e.originalEvent.dataTransfer.dropEffect = 'copy';
		}

		$(this).addClass('is-dragover').removeClass('is-error');
	});

	$(document).on('dragleave dragend', '[data-profile-dropzone]', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$(this).removeClass('is-dragover');
	});

	$(document).on('drop', '[data-profile-dropzone]', function(e) {
		e.preventDefault();
		e.stopPropagation();

		const files = e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files;
		const file = files && files.length ? files[0] : null;
		const input = document.getElementById($(this).attr('for'));

		$(this).removeClass('is-dragover');

		if (!file || !input) {
			return;
		}

		if (!isPdfFile(file)) {
			updateProfileRibFile($(input), file);
			return;
		}

		if (assignProfileRibDropFile(input, file)) {
			$(input).trigger('change');
		} else {
			setProfileRibDropError($(input), 'Cliquez pour sélectionner ce fichier PDF');
		}
	});

	// -- upload file(s) --
	$(document).on('change', '.organizersForm input', function(e) { 
    e.preventDefault();
		var $form = $(this).parents('form');
    submitForm($form);
	});

	// -- save entry --
	function submitForm($form) {
		var formData = new FormData($form[0]);
		$form.find('.form__content').css({'opacity': '.1'});
		$form.find('.icon--loader').removeClass('hidden');
		$.ajax({
			type: "POST",
			url: $form.find('input[name=action]').val(),
			dataType: 'json',
			data: formData,
			contentType: false,
			processData: false,
			success: function (response) {
				// console.log(response);
				notificationEl.find('.notification__inner').text(response.message);
				notificationEl.removeClass('-translate-y-40');
				
				// -- update dashboard template --
				$.ajax({
					url: window.location.href,
					type: 'GET',
					success: function(updatedEntryData){
						// console.log(updatedEntryData);
						var updatedForm = $(updatedEntryData).find(`#${$form[0].id}`).parent().html();
						$form.parent().html(updatedForm);
					  $('.section').removeClass('section--locked');
					  $('.section.locked__content').hide();						
					},
					error: function (error) {
						// console.log(error);
						window.location.reload();
					},
					complete: function() {
						$form.find('.form__content').css({'opacity': '1'});
						$form.find('.icon--loader').addClass('hidden');
					}
				});				
    	},
			error: function (error) {
				// console.log(error);
				notificationEl.find('.notification__inner').text(error.message);
				notificationEl.removeClass('-translate-y-40');
				window.location.reload();
			},
			complete: function (xhr) {
				// console.log(xhr);
				$form.find('.form__content').css({'opacity': '1'});
				$form.find('.icon--loader').addClass('hidden');
				setTimeout(function(){
					notificationEl.addClass('-translate-y-40');
				}, 2500);
				setTimeout(function(){
					notificationEl.find('.notification__inner').text('');
				}, 5000);
			}
		});
	}

	// -- multi upload : delete files --
	$('.deleteFileForm').on('submit', function(e){
		e.preventDefault();
		var $form = $(this);
		var formData = new FormData($(this)[0]);
		$.ajax({
			type: "POST",
			url: $(this).find('input[name=action]').val(),
			dataType: 'json',
			data: formData,
			contentType: false,
			processData: false,
			success: function (response) {
				notificationEl.find('.notification__inner').text(response.message);
				notificationEl.removeClass('-translate-y-40');
				$form.parents('.fileElement').remove();
    	},
			error: function (error) {
				window.location.reload();
			},
			complete: function (xhr) {
				setTimeout(function(){
					notificationEl.addClass('-translate-y-40');
				}, 2500);
				setTimeout(function(){
					notificationEl.find('.notification__inner').text('');
				}, 5000);
			}
		});
	});

});
